// A Firebase email sign-in link lands on /runs?apiKey=...&oobCode=...: a live single-use
// credential in the address bar. This module runs first (imported at the top of main.jsx, before
// analytics or any route chunk) and takes the code off the URL, keeping a copy for the sign-in
// itself (security review, PR #12). Nothing else may read window.location for it.
let captured = null;

export function scrubSignInLink(win = window) {
  try {
    const href = win.location.href;
    if (!/[?&]oobCode=/.test(href)) return null;
    captured = href;
    const clean = new URL(href);
    for (const p of ['oobCode', 'apiKey', 'mode', 'continueUrl', 'lang']) clean.searchParams.delete(p);
    win.history.replaceState({}, '', clean.pathname + (clean.search || '') );
    return href;
  } catch {
    return null;
  }
}

/** The link as it arrived, or null when the page was not opened from one. */
export function signInHref() {
  return captured;
}

scrubSignInLink();
